import getAxios from "./axiosService";
import userService from "./userService";

let STATICAPI = true;
let traceId = null; // userService.getTraceId();

function getUrl(route) {
  // route += '?';
  if (traceId) {
    route += `User-Trace-Id=${traceId}`;
  }
  return route;
}

let bookService = {
  getDetail(id) {
    return new Promise((resolve, reject) => {
      let axios = getAxios(STATICAPI);
      //axios.get(`/api/book/detail?bookId=${id}`)
      axios.get(`/api/book/detail/${id}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          } else {
            console.error(`Get book ${id} detail with error`, res);
            reject();
          }
        })
    })
  },
  getChapters(id) {
    return new Promise((resolve, reject) => {
      let axios = getAxios();
      axios({
        method: 'post',
        url: `/api/book/chapter/list?bookId=${id}`,
        data: {
          bookId: id
        },
        transformRequest: [
          function (data) {
            let ret = '';
            for (let item in data) {
              ret += `${encodeURIComponent(item)}=${encodeURIComponent(data[item])}&`
            }
            return ret;
          }
        ]
      })
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          } else {
            reject();
          }
        })
    })
  },
  getChapterImg(id, number) {
    return new Promise((resolve, reject) => {
      let axios = getAxios();
      axios.get(`/api/book/read_chapter?bookId=${id}&number=${number}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          } else {
            reject();
          }
        })
    })
  },
  buyChapter(id) {
    return new Promise((resolve, reject) => {

      let axios = getAxios();
      axios.post('/api/book/chapter/buy', {}, {
        params: {
          chapterId: id
        }
      })
        .then(res => {
          if(res.status === 200) {
            resolve(res.data);
          }
          else {
            reject();
          }
        })
    })
  }
}

export default bookService



// WEBPACK FOOTER //
// ./src/services/bookService.js